import { useEffect } from 'react'
import SignupForm from 'components/SignupForm'
import { selectLoggedIn } from 'selectors/auth'
import { Grid, Row, Col } from 'components/utils/Grid'
import { useAppSelector } from 'store/hooks'

const Signup = () => {
  const { loggedIn } = useAppSelector(selectLoggedIn)

  useEffect(() => {
    if (loggedIn) {
      window.location.href = '/graph'
    }
  }, [loggedIn])

  return (
    <Grid>
      <Row>
        {loggedIn ? <div /> : null}
        <Col sm={5} smPush={1}>
          <h2>Signup</h2>
          <SignupForm />
        </Col>
      </Row>
    </Grid>
  )
}

export default Signup
